import React from "react";
import styled from "styled-components";
import {
  buildBreadcrumbStructuredData,
  StructuredData,
} from "./StructuredData";

export interface BreadcrumbsProps {
  breadcrumbs: {
    title: string;
    href: string;
  }[];
  origin: string;
}

export function Breadcrumbs({ breadcrumbs, origin }: BreadcrumbsProps) {
  const breadcrumbStructuredData = buildBreadcrumbStructuredData({
    breadcrumbs,
    origin,
  });
  return (
    <>
      <StructuredData structuredData={breadcrumbStructuredData} />
      <BreadcrumbsOl>
        {breadcrumbs.map((breadcrumb) => (
          <Breadcrumb
            key={JSON.stringify(breadcrumb)}
            breadcrumb={breadcrumb}
          />
        ))}
      </BreadcrumbsOl>
    </>
  );
}

const BreadcrumbsOl = styled.ol`
  padding-left: 0;
  list-style: none;
  margin-bottom: 0;
`;

interface BreadcrumbProps {
  breadcrumb: {
    title: string;
    href: string;
  };
}

function Breadcrumb({ breadcrumb }: BreadcrumbProps) {
  return (
    <BreadcrumbLi>
      <a href={breadcrumb.href} aria-label={breadcrumb.title}>
        <span>{breadcrumb.title}</span>
      </a>
    </BreadcrumbLi>
  );
}

const BreadcrumbLi = styled.li`
  display: inline-block;
  font-size: ${(props) => props.theme.typography.typeScale[50]};

  &:not(:last-child):after {
    content: "\\203A";
    /*  Single Right-Pointing Angle Quotation Mark */
    margin-left: ${(props) => props.theme.spacing.xs};
    margin-right: ${(props) => props.theme.spacing.xs};
  }

  a {
    color: ${(props) => props.theme.color.link};
  }
`;
